import {useDispatch,useSelector} from 'react-redux';
import { NavLink } from "react-router"
import { GiShoppingCart } from "react-icons/gi";
const Sidebar  = () =>{
   const language = useSelector((state) => {
        return state.settingreducer.language;
   });
   return(
     <>
     {/* {data-background-color="dark"} */}
     {/* {data-background-color="dark"} */}
            <div className="sidebar navbar-light bg-white" >
                    <div className="sidebar-logo">

                        <div className="logo-header navbar-light bg-white" >
                            <a href="/" className="logo">
                                <div className='flex-box flex-align-item-center'>
                                     <img
                                    src="utan logo.png"
                                    alt="navbar brand"
                                    className="navbar-brand"
                                    height="46"
                                   /> 
                                   <h3 style={{color:'grey',textAlign:'center',fontSize:'16px'}}>Utan</h3>
                                </div>
                            </a>
                            <div className="nav-toggle">
                                <button className="btn btn-toggle toggle-sidebar">
                                    <i className="gg-menu-right"></i>
                                </button>
                                <button className="btn btn-toggle sidenav-toggler">
                                    <i className="gg-menu-left"></i>
                                </button>
                            </div>
                            <button className="topbar-toggler more">
                                <i className="gg-more-vertical-alt"></i>
                            </button>
                        </div>

                    </div>
                    <div class="sidebar-wrapper scrollbar scrollbar-inner">
                        <div class="sidebar-content">

                            <ul class="nav nav-secondary">
                                <li class="nav-item ">
                                    <NavLink to='/dashboard'><i class="fas fa-home"></i> {language.dashboard} </NavLink>
                                </li>

                                 <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#mastersLayouts">
                                       <i class="fa fa-cog" aria-hidden="true"></i>
                                        {/* <GiShoppingCart/> */}
                                        <p> Masters</p>
                                        <span class="caret"></span>
                                    </a>

                                    <div class="collapse" id="mastersLayouts">
                                       <ul class="nav nav-collapse">
                                             <li class="nav-item">
                                                    <NavLink to='/categories'><i class="fa fa-angle-right"></i> Categories</NavLink>
                                                </li>
                                              <li class="nav-item">
                                                    <NavLink to='/components'><i class="fa fa-angle-right"></i> {language.components}</NavLink>
                                                </li>

                                                <li class="nav-item">
                                                    <NavLink to='/bom'><i class="fa fa-angle-right"></i> {language.billofmaterial}</NavLink>
                                                </li>

                                                <li class="nav-item">
                                                    <NavLink to='/product'><i class="fa fa-angle-right"></i> {language.product}</NavLink>
                                                </li>
                                        </ul>
                                    </div>  

                                       
                                </li> 


                                <li class="nav-item">
                                    <NavLink to='/alertreminders'><i class="fa fa-angle-right"></i> {language.alertsandReminders}</NavLink>
                                </li>

                               

                                <li class="nav-item">
                                    <NavLink to='/freight'><i class="fa fa-angle-right"></i>Freight Providers</NavLink>
                                </li>

                            
                                <li class="nav-item">
                                    <NavLink to='/warehouses/index'><i class="fa fa-angle-right"></i> Warehouses</NavLink>
                                </li> 
                                


                                <li class="nav-item">
                                    <NavLink to='/shipment'><i class="fa fa-angle-right"></i>Shipment</NavLink>
                                </li>

                                 <li class="nav-item">
                                    <NavLink to='/stocks'><i class="fa fa-angle-right"></i> {language.stocks}</NavLink>
                                </li>

                                <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#InventryLayouts">
                                       <i class="fa fa-warehouse" aria-hidden="true"></i>
                                        {/* <GiShoppingCart/> */}
                                        <p> Inventry</p>
                                        <span class="caret"></span>
                                    </a>

                                    <div class="collapse" id="InventryLayouts">
                                       <ul class="nav nav-collapse">
                                                <li class="nav-item">
                                               <NavLink to='/stocktransfers'><i class="fa fa-angle-right"></i> Stock Transfers</NavLink>
                                            </li> 
                                            <li class="nav-item">
                                               {/* <NavLink to='/stocktransfers'><i class="fa fa-angle-right"></i> WH/Stocks </NavLink> */}
                                            </li> 
                                             {/* <li class="nav-item">
                                                <NavLink to='/purchaseorder'><i class="fa fa-angle-right"></i> {language.purchaseorder}</NavLink>
                                            </li>    */}
                                        </ul>
                                    </div> 

                                   
                                 </li>

                                 

                                 <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#purchasesLayouts">
                                       <i class="fa fa-shopping-bag" aria-hidden="true"></i>
                                        {/* <GiShoppingCart/> */}
                                        <p> Purchases</p>
                                        <span class="caret"></span>
                                    </a>

                                    <div class="collapse" id="purchasesLayouts">
                                       <ul class="nav nav-collapse">
                                                <li class="nav-item">
                                               <NavLink to='/suppliers'><i class="fa fa-angle-right"></i> {language.suppliers}</NavLink>
                                            </li> 
                                             <li class="nav-item">
                                                <NavLink to='/purchaseorder'><i class="fa fa-angle-right"></i> {language.purchaseorder}</NavLink>
                                            </li>   
                                        </ul>
                                    </div> 
                                 </li>   


                                <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#settingsLayouts">
                                       <i class="fa fa-shopping-cart" aria-hidden="true"></i>
                                        {/* <GiShoppingCart/> */}
                                        <p> Orders / Sales</p>
                                        <span class="caret"></span>
                                    </a>

                                    <div class="collapse" id="settingsLayouts">
                                       <ul class="nav nav-collapse">
                                            <li class="nav-item">
                                                <NavLink to='/orders'><i class="fa fa-angle-right"></i> Orders</NavLink>
                                            </li>    
                                             <li class="nav-item">
                                                <NavLink to='/salesfullfilment'><i class="fa fa-angle-right"></i> Sales & Fulfillment</NavLink>
                                            </li> 
                                        </ul>
                                    </div>  

                                       
                                </li>    

                                <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#sidebarLayouts">
                                        <i class="fas fa-truck"></i>
                                        <p>Tracking</p>
                                        <span class="caret"></span>
                                    </a>
                                    <div class="collapse" id="sidebarLayouts">
                                        <ul class="nav nav-collapse">
                                            <li class="nav-item">
                                                <NavLink to='/stocktracking'> <i class="fa fa-angle-right"></i>Stock Tracking</NavLink>
                                            </li>
                                            <li class="nav-item">
                                                <NavLink to='/ordertracking'> <i class="fa fa-angle-right"></i>Order Tracking</NavLink>
                                            </li>
                                            <li class="nav-item">
                                                <NavLink to='/producttracking'> <i class="fa fa-angle-right"></i>Product Tracking</NavLink>
                                            </li>
                                            
                                            <li class="nav-item">
                                                <NavLink to='/billofmaterial'> <i class="fa fa-angle-right"></i>{language.frecklefluidusage}</NavLink>
                                            </li>


                                            <li class="nav-item">
                                                <NavLink to='/billofmaterial'> <i class="fa fa-angle-right"></i>{language.totalfluidused}</NavLink>
                                            </li>

                                            {/* <li class="nav-item">
                                                <NavLink to='/billofmaterial'> <i class="fa fa-angle-right"></i>{language.stocklevelupdate}</NavLink>
                                            </li> */}

                                            <li class="nav-item">
                                                <NavLink to='/shipmenttracking'><i class="fa fa-angle-right"></i> {language.shipmenttracking}</NavLink>
                                            </li> 

                                            

                                            

                                             {/* <li class="nav-item">
                                                <NavLink to='/billofmaterial'><i class="fas fa-user"></i> {language.tracking}</NavLink>
                                            </li> */}
                                        </ul>
                                    </div>
                                </li>
                                <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#forcastLayouts">
                                        <i class="fa fa-file"></i>
                                        <p> Forecast</p>
                                        <span class="caret"></span>
                                    </a>

                                    <div class="collapse" id="forcastLayouts">
                                       <ul class="nav nav-collapse">
                                            <li class="nav-item">
                                                <NavLink to='/forecast'><i class="fa fa-angle-right"></i> Forcasting</NavLink>
                                            </li> 
                                           
                                        </ul>
                                    </div>    
                                </li> 
                                <li class="nav-item">
                                    <a data-bs-toggle="collapse" href="#reportLayouts">
                                        <i class="fa fa-file"></i>
                                        <p> Reports</p>
                                        <span class="caret"></span>
                                    </a>

                                    <div class="collapse" id="reportLayouts">
                                       <ul class="nav nav-collapse">
                                            <li class="nav-item">
                                                <NavLink to='/stockreports'><i class="fa fa-angle-right"></i> Stock Reports</NavLink>
                                            </li> 
                                            <li class="nav-item">
                                                <NavLink to='/stocksproductreports'><i class="fa fa-angle-right"></i> Stock Product Reports</NavLink>
                                            </li> 
                                            <li class="nav-item">
                                                <NavLink to='/salesreport'><i class="fa fa-angle-right"></i> Sales Reports</NavLink>
                                            </li> 

                                            <li class="nav-item">
                                                <NavLink to='/purchaseorderreport'><i class="fa fa-angle-right"></i> Purchase Order Reports</NavLink>
                                            </li>

                                            <li class="nav-item">
                                                <NavLink to='/profitlossreport'><i class="fa fa-angle-right"></i> P&L Report</NavLink>
                                            </li>
                                        </ul>
                                    </div>    
                                </li>  


                                  

                                
                                
                                <li className="nav-item">
                                    <NavLink to='/Users'>
                                    <i className="fas fa-user"></i> 
                                    {language.users}</NavLink>
                                </li>

                                {/* <li class="nav-item">
                                    <NavLink to='/accesscontrol'><i class="fa fa-users"></i> {language.createclient}</NavLink>
                                </li>

                                <li class="nav-item">
                                    <NavLink to='/accesscontrol'><i class="fa fa-universal-access"></i> {language.accesscontrol}</NavLink>
                                </li> */}

                                {/* <li class="nav-item">
                                    <NavLink to='/settings'><i class="fa fa-cog"></i> {language.settings}</NavLink>
                                </li> */}
                                {/* <li class="nav-section">
                                    <span class="sidebar-mini-icon">
                                        <i class="fa fa-ellipsis-h"></i>
                                    </span>
                                    <h4 className="text-section">Components</h4>
                                </li> */}
                                {/* <li className="nav-item">
                                    <a data-bs-toggle="collapse" href="#base">
                                        <i className="fas fa-layer-group"></i>
                                        <p>Base</p>
                                        <span className="caret"></span>
                                    </a>
                                    <div className="collapse" id="base">
                                        <ul className="nav nav-collapse">
                                            <li>
                                                <a href="components/avatars.html">
                                                    <span className="sub-item">Avatars</span>
                                                </a>
                                            </li>

                                            
                                            
                                            <li>
                                                <a href="components/buttons.html">
                                                    <span className="sub-item">Buttons</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="components/gridsystem.html">
                                                    <span className="sub-item">Grid System</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="components/panels.html">
                                                    <span className="sub-item">Panels</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="components/notifications.html">
                                                    <span className="sub-item">Notifications</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="components/sweetalert.html">
                                                    <span className="sub-item">Sweet Alert</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="components/font-awesome-icons.html">
                                                    <span className="sub-item">Font Awesome Icons</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="components/simple-line-icons.html">
                                                    <span className="sub-item">Simple Line Icons</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="components/typography.html">
                                                    <span className="sub-item">Typography</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <a data-bs-toggle="collapse" href="#sidebarLayouts">
                                        <i className="fas fa-th-list"></i>
                                        <p>Sidebar Layouts</p>
                                        <span className="caret"></span>
                                    </a>
                                    <div className="collapse" id="sidebarLayouts">
                                        <ul className="nav nav-collapse">
                                            <li>
                                                <a href="sidebar-style-2.html">
                                                    <span className="sub-item">Sidebar Style 2</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="icon-menu.html">
                                                    <span className="sub-item">Icon Menu</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <a data-bs-toggle="collapse" href="#forms">
                                        <i className="fas fa-pen-square"></i>
                                        <p>Forms</p>
                                        <span className="caret"></span>
                                    </a>
                                    <div className="collapse" id="forms">
                                        <ul className="nav nav-collapse">
                                            <li>
                                                <a href="forms/forms.html">
                                                    <span className="sub-item">Basic Form</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <a data-bs-toggle="collapse" href="#tables">
                                        <i className="fas fa-table"></i>
                                        <p>Tables</p>
                                        <span className="caret"></span>
                                    </a>
                                    <div className="collapse" id="tables">
                                        <ul className="nav nav-collapse">
                                            <li>
                                                <a href="tables/tables.html">
                                                    <span className="sub-item">Basic Table</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="tables/datatables.html">
                                                    <span className="sub-item">Datatables</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <a data-bs-toggle="collapse" href="#maps">
                                        <i className="fas fa-map-marker-alt"></i>
                                        <p>Maps</p>
                                        <span className="caret"></span>
                                    </a>
                                    <div className="collapse" id="maps">
                                        <ul className="nav nav-collapse">
                                            <li>
                                                <a href="maps/googlemaps.html">
                                                    <span className="sub-item">Google Maps</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="maps/jsvectormap.html">
                                                    <span className="sub-item">Jsvectormap</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <a data-bs-toggle="collapse" href="#charts">
                                        <i className="far fa-chart-bar"></i>
                                        <p>Charts</p>
                                        <span className="caret"></span>
                                    </a>
                                    <div className="collapse" id="charts">
                                        <ul className="nav nav-collapse">
                                            <li>
                                                <a href="charts/charts.html">
                                                    <span className="sub-item">Chart Js</span>
                                                </a>
                                            </li>
                                            <li>
                                                <a href="charts/sparkline.html">
                                                    <span className="sub-item">Sparkline</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li>
                                <li className="nav-item">
                                    <a href="widgets.html">
                                        <i className="fas fa-desktop"></i>
                                        <p>Widgets</p>
                                        <span className="badge badge-success">4</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a href="../../documentation/index.html">
                                        <i className="fas fa-file"></i>
                                        <p>Documentation</p>
                                        <span className="badge badge-secondary">1</span>
                                    </a>
                                </li>
                                <li className="nav-item">
                                    <a data-bs-toggle="collapse" href="#submenu">
                                        <i className="fas fa-bars"></i>
                                        <p>Menu Levels</p>
                                        <span className="caret"></span>
                                    </a>
                                    <div className="collapse" id="submenu">
                                        <ul className="nav nav-collapse">
                                            <li>
                                                <a data-bs-toggle="collapse" href="#subnav1">
                                                    <span className="sub-item">Level 1</span>
                                                    <span className="caret"></span>
                                                </a>
                                                <div className="collapse" id="subnav1">
                                                    <ul className="nav nav-collapse subnav">
                                                        <li>
                                                            <a href="#">
                                                                <span className="sub-item">Level 2</span>
                                                            </a>
                                                        </li>
                                                        <li>
                                                            <a href="#">
                                                                <span className="sub-item">Level 2</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li>
                                                <a data-bs-toggle="collapse" href="#subnav2">
                                                    <span className="sub-item">Level 1</span>
                                                    <span className="caret"></span>
                                                </a>
                                                <div className="collapse" id="subnav2">
                                                    <ul className="nav nav-collapse subnav">
                                                        <li>
                                                            <a href="#">
                                                                <span className="sub-item">Level 2</span>
                                                            </a>
                                                        </li>
                                                    </ul>
                                                </div>
                                            </li>
                                            <li>
                                                <a href="#">
                                                    <span className="sub-item">Level 1</span>
                                                </a>
                                            </li>
                                        </ul>
                                    </div>
                                </li> */}
                            </ul>
                        </div>
                    </div>
                </div>       
     </>
   );   
}

export default Sidebar;

